import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Button } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaFormatosGeneralesInterface } from "../../../../../interfaces/FechaFormatosGeneralesInterface";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import fotoMapa from "../../../../../img/fotoMapa.png";

export const AutorizacionProporcionarDocumentosListaPrint = () => {
  const tituloFormulario =
    "AUTORIZACIÓN PARA PROPORCIONAR DOCUMENTOS E INFORMACIÓN";
  const [formData, setFormData] = useState({
    date: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { reset } = useForm();

  const queryFechaFG = useGetData<FechaFormatosGeneralesInterface>({
    url: `/fecha_formatosgenerales/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha_formatosgenerales"],
  });

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  useEffect(() => {
    if (queryFechaFG.data) {
      const fechafg = queryFechaFG.data;
      reset({
        fecha_requisitos_pruebas: fechafg.fecha_requisitos_pruebas || "",
      });
    }
  }, [queryFechaFG.data, reset]);

  const navigate = useNavigate();

  const handlePrint = () => {
    const printContent = document.getElementById("printableContent");

    if (printContent) {
      const printWindow = window.open("", "", "width=800,height=600");

      if (printWindow) {
        printWindow.document.write(`
          <html>
            <head>
              <title>Vista Previa de Impresión</title>
              <style>
                @media print {
                  body {
                    margin: 20px;
                    font-family: Arial, sans-serif;
                  }
                }
              </style>
            </head>
            <body>${printContent.innerHTML}</body>
          </html>
        `);

        const styles = document.styleSheets;
        for (let i = 0; i < styles.length; i++) {
          try {
            if (styles[i].cssRules) {
              const styleTag = printWindow.document.createElement("style");
              for (let j = 0; j < styles[i].cssRules.length; j++) {
                styleTag.appendChild(
                  printWindow.document.createTextNode(
                    styles[i].cssRules[j].cssText
                  )
                );
              }
              printWindow.document.head.appendChild(styleTag);
            }
          } catch (e) {
            console.warn("No se pudo copiar una hoja de estilo:", e);
          }
        }

        printWindow.document.close();
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
            printWindow.close();
          }, 500);
        };
      } else {
        alert("No se pudo abrir la ventana de impresión.");
      }
    }
  };

  return (
    <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden mt-4 mb-4 relative">
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>

      {/* Contenido del formulario */}
      <div className="p-6">
        <div className="space-y-6">
          <p className="text-justify text-gray-800 leading-relaxed">
            <span className="mr-2">
              Bajo protesta de decir verdad hago constar que los datos
              proporcionados en el proceso de evaluación son verdaderos.
            </span>
          </p>

          <p className="text-justify">
            Asimismo; autorizo a los{" "}
            <span>
              {queryFechaFG.data?.fecha_autorizacion_proporcionar
                ? (() => {
                    const date = new Date(
                      queryFechaFG.data.fecha_autorizacion_proporcionar
                    );
                    date.setDate(date.getDate() + 1);
                    return date.toLocaleDateString("es-ES", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    });
                  })()
                : "Fecha no disponible"}
            </span>{" "}
            a la empresa SKA TRACKING AND SECURITY S.A. de C.V. para que
            proporcione toda la documentación e información derivada de mis
            evaluaciones.
          </p>

          <p className="text-justify">
            Se firma la presente por triplicado para los efectos legales
            conducentes
          </p>
        </div>
        <br />
        <br />
        <div className="text-left mb-8">
          <h2 className="text-xl font-bold mb-2 flex items-left">
            {`NOMBRE: ${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
          </h2>
          <h2 className="text-xl font-bold mb-2 flex items-left">
            {`PUESTO: ${queryEvaluado.data?.puesto || ""}`}
          </h2>
          <h2 className="text-xl font-bold mb-2 flex items-left">
            {`FIRMA: `}
          </h2>
        </div>
      </div>

      <div className="mt-[350px]"></div>

      {/* Footer */}
      <div className="bg-customBlue/90 py-2 rounded-b-lg w-full">
        <p className="text-white text-xs text-center font-light px-4">
          <span className="font-medium">DOCUMENTO CONFIDENCIAL</span> •
          Prohibida su reproducción o copia fuera de las instalaciones de
          Skyangel.
        </p>
      </div>
    </div>
  );
};
